import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Block Content Title and Content",
  name: "blockContentTitleAndContent",
  type: "object",
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || ""
      };
    }
  }
});
